(function ($) {
  // Set menu css variables
  function haseSubMenu(menuItem) {
    return menuItem.find('ul').length > 0 ? true : false;
  }

  const menuItems = $('#primary-menu>li');
  if (menuItems.length > 0) {
    menuItems.each(function () {
      if (haseSubMenu($(this))) {
        const subMenu = $(this).find('ul');
        const subMenuTitle = $(this).find('a span').first().text();
        subMenu.css("--title", '"' + subMenuTitle + '"');
      }
    });
  }

  //Mobile menu
  // Add second level artifacts
  const menu = $('#primary-menu');
  $('#primary-menu .sub-menu').each(function () {
    $('<li class="menu-back-btn">Tilbake</li>')
      .on('click', function () {
        window.setTimeout(function () {
          // Add delay to animate.
          menu.find('li.sub-menu-opened').removeClass('sub-menu-opened');
        }, 300);
        menu.removeClass('show-level-2');
      })
      .prependTo($(this));
  });

  // Navigation to second level
  $("#primary-menu .menu-item-has-children > a").on('click', function (event) {
    event.preventDefault();
    $(this).parent().addClass('sub-menu-opened');
    menu.addClass('show-level-2');
  });

  //Navigation label and mobile menu basic logic
  function changeNavText(label, open, close) {
    label.text() === open ? label.html(close) : label.html(open);
  }

  $('.navbar-toggler').on('click', function (event) {
    event.preventDefault();
    const label = $('.mobile-menu-title');
    const navTextOpen = label.data('open');
    const navTextClose = label.data('close');

    $('body').toggleClass('menu-open');
    changeNavText(label, navTextOpen, navTextClose);
    $('.menu-back-btn').trigger('click');
  });
}(jQuery));